"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCategory = exports.getSubTypeIdsBySubType = exports.flattenIssueTypes = void 0;
var _sortingHelpers = require("./sortingHelpers");
var _lodash = require("lodash");
// our app strips the "types" key from the srver and replaces it
// with "childrenIds". It flattens the payload, hence the name "FlattendIssueType"

const isCategory = typeOrCategory => {
  return !typeOrCategory.issueTypeCategoryId;
};

// children ids (which represent issue types) are sorted by title
exports.isCategory = isCategory;
const flattenIssueTypes = entitiesList => entitiesList.reduce((acc, category) => {
  acc[category.id] = {
    ...category
  };
  if (category.types) {
    acc[category.id].childrenIds = category.types.sort(_sortingHelpers.localeCompareByTitle).map(type => {
      acc[type.id] = type;
      acc[type.id].parentId = category.id;
      return type.id;
    });
  }
  delete acc[category.id].types;
  return acc;
}, {});
exports.flattenIssueTypes = flattenIssueTypes;
const getSubTypeIdsBySubType = (groupedTypes, subType) => {
  const flattenedTypes = flattenIssueTypes((0, _lodash.cloneDeep)(groupedTypes));
  const subTypeIds = Object.keys(flattenedTypes).reduce((acc, id) => {
    const type = flattenedTypes[id];
    if (type.fieldsMetadata && type.fieldsMetadata.some(f => f.id === subType && f.visible)) {
      acc.push(id);
    }
    return acc;
  }, []);
  return subTypeIds;
};
exports.getSubTypeIdsBySubType = getSubTypeIdsBySubType;
//# sourceMappingURL=issueTypeUtils.js.map